import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export default function CTASection() {
  const { t } = useTranslation();

  return (
    <section className="w-full">
      <div className="flex flex-col lg:flex-row">
        <div className="relative w-full lg:w-1/2 h-[400px] md:h-[500px] lg:h-[600px] overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Abstract%20modern%20composition%20with%20warm%20cream%20and%20beige%20tones%2C%20soft%20artistic%20textures%2C%20subtle%20geometric%20shapes%20floating%20elegantly%2C%20editorial%20minimalist%20aesthetic%2C%20gentle%20gradients%2C%20sophisticated%20magazine%20style%2C%20clean%20and%20airy%20atmosphere%2C%20no%20text%20or%20human%20faces%2C%20pure%20abstract%20art&width=960&height=1200&seq=cta-left-image&orientation=portrait"
            alt="51吃瓜APP"
            className="w-full h-full object-cover object-top"
            title="51吃瓜APP下载"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-background-50/50 to-transparent"></div>
          <div className="absolute top-8 left-8">
            <span className="inline-block px-3 py-1 rounded-full bg-background-50/90 text-foreground-700 text-xs font-semibold whitespace-nowrap">
              {t('cta.tag')}
            </span>
          </div>
          <div className="absolute bottom-10 left-8 right-8">
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-black text-foreground-950 leading-tight">
              {t('cta.title.line1')}
              <br />
              {t('cta.title.line2')}
              <br />
              {t('cta.title.line3')}
            </h2>
          </div>
        </div>

        <div className="w-full lg:w-1/2 bg-background-50 flex flex-col items-center justify-center px-8 md:px-14 py-14 md:py-20">
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-black text-foreground-950 leading-tight text-center">
            {t('cta.main.title.line1')}
            <br />
            {t('cta.main.title.line2')}
          </h2>
          <p className="mt-6 text-sm md:text-base text-foreground-600 leading-relaxed text-center max-w-md">
            {t('cta.main.desc')}
          </p>
          <Link
            to="/category/hot"
            className="inline-flex items-center gap-2 mt-8 px-8 py-3.5 rounded-full bg-primary-500 text-white text-base font-semibold whitespace-nowrap hover:bg-primary-600 transition-all duration-300 cursor-pointer"
          >
            {t('cta.main.button')}
            <i className="ri-arrow-right-line w-5 h-5 flex items-center justify-center"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}